import {Component, EventEmitter, forwardRef, Input, OnChanges, Output, ViewChild} from '@angular/core'
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms'
import { FilterOption } from '../../../pages/coupon-codes/models/rewards-model'
import { CommonModule } from '@angular/common'
import { TranslocoModule } from '@jsverse/transloco'

@Component({
  selector: 'pf-filter-select',
  templateUrl: './filter-select.component.html',
  styleUrls: ['./filter-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterSelectComponent),
      multi: true,
    },
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslocoModule,
  ],
})
export class FilterSelectComponent implements ControlValueAccessor, OnChanges {
  @ViewChild('filterRef', { static: true }) filterRef
  @Input() title: string = 'Filter by'
  @Input() width: string
  @Input() options: { value: string, title?: string, titleKey?: string, group?: string, groupTitleKey?: string }[] = []
  @Output() change = new EventEmitter<FilterOption>()

  groupArr: { group: string, groupTitleKey?: string, groupItem: { value: string, title?: string, titleKey?: string, group?: string, groupTitleKey?: string }[] }[] = []
  value: string
  private _onChange: Function

  constructor() {
  }

  ngOnChanges() {
    this._buildGroupArr()
  }

  private _buildGroupArr() {
    this.groupArr = this.options.reduce((r, opt) => {
      const { group } = opt
      if (!r.some(o => o.group === group)) {
        r.push({
          group,
          groupTitleKey: opt.groupTitleKey,
          groupItem: this.options.filter(v => v.group === group),
        })
      }
      return r
    }, [])
  }

  writeValue(value) {
    if (value === undefined || value === null) {
      return
    }
    this.value = value

    this._buildGroupArr()
  }

  registerOnChange(fn) {
    this._onChange = fn
  }

  registerOnTouched(fn) {
    // this._onTouched = fn
  }

  filterChanged(event) {
    this.value = event.target.value
    this._onChange && this._onChange(this.value)
  }
}
